import { render, staticRenderFns } from "./HKLPencilTextarea.vue?vue&type=template&id=377f366a&scoped=true&"
import script from "./HKLPencilTextarea.vue?vue&type=script&lang=js&"
export * from "./HKLPencilTextarea.vue?vue&type=script&lang=js&"
import style0 from "./HKLPencilTextarea.vue?vue&type=style&index=0&id=377f366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f366a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377f366a')) {
      api.createRecord('377f366a', component.options)
    } else {
      api.reload('377f366a', component.options)
    }
    module.hot.accept("./HKLPencilTextarea.vue?vue&type=template&id=377f366a&scoped=true&", function () {
      api.rerender('377f366a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Input/HKLPencilTextarea.vue"
export default component.exports